import React from 'react'
import classnames from 'classnames'

import { Accordion, QuantityDisplay } from '@fielded/shared-ui'
import { Chevron, ExclamationTriangle } from '@fielded/shared-ui/src/icons'

const PickUpContentsTableItems = ({
  isExpanded,
  batches,
  withAdjustmentsFeature
}) => {
  return (
    <Accordion>
      <Accordion.Section isExpanded={isExpanded}>
        <Accordion.Section.Content>
          <table className='pick-up-contents__sub-table'>
            <thead>
              <tr>
                <th className='pick-up-contents__icon'>&nbsp;</th>
                <th
                  className={classnames(
                    'pick-up-contents__name',
                    'pick-up-contents__name--sub',
                    {'pick-up-contents__name--with-adjustments': withAdjustmentsFeature}
                  )}
                >
                  Products
                </th>
                <th
                  className={classnames(
                    'pick-up-contents__quantity',
                    'pick-up-contents__quantity--sub',
                    {'pick-up-contents__quantity--with-adjustments': withAdjustmentsFeature}
                  )}
                >
                  Qty
                </th>
                {withAdjustmentsFeature && (
                  <th className='pick-up-contents__adjustment pick-up-contents__adjustment--sub'>Adjusted Qty</th>
                )}
              </tr>
            </thead>

            <tbody>
              {batches.map(({ _id, name, picked, adjustment }) => (
                <tr
                  key={_id}
                  className={classnames(
                    'pick-up-contents__sub-table-row',
                    {'pick-up-contents__sub-table-row--adjustment': !!adjustment && withAdjustmentsFeature}
                  )}>
                  <td className='pick-up-contents__icon'>
                    <Chevron direction={isExpanded ? 'up' : 'down'} />
                  </td>
                  <td
                    className={classnames(
                      'pick-up-contents__name',
                      {'pick-up-contents__name--with-adjustments': withAdjustmentsFeature}
                    )}
                  >
                    {name}
                  </td>
                  <td
                    className={classnames(
                      'pick-up-contents__quantity',
                      {'pick-up-contents__quantity--with-adjustments': withAdjustmentsFeature}
                    )}
                  >
                    <QuantityDisplay
                      value={adjustment && withAdjustmentsFeature ? adjustment.original : picked}
                    />
                  </td>
                  {withAdjustmentsFeature && (
                    <td className='pick-up-contents__adjustment'>
                      <span className='vs-u-row vs-u-align-center vs-u-gap-half'>
                        <QuantityDisplay value={picked} />
                        {adjustment && (
                          <span
                            className='pick-up-contents__diff-icon'>
                            <ExclamationTriangle />
                          </span>
                        )}
                      </span>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </Accordion.Section.Content>
      </Accordion.Section>
    </Accordion>
  )
}

export default PickUpContentsTableItems
